<template>
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-3 page-title">
            <h3 class="text-center mt-2 mal-text custom-title">സ്നേഹ സ്പർശം</h3>
        </div>
    </div>

    <div class="section text-center" v-if="loading">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>

    <div class="section pt-1" v-if="!loading">
        <p class="text-muted mal-text px-2 mb-2">പദ്ധതി തിരഞ്ഞെടുത്ത് അപേക്ഷ സമർപ്പിക്കുക.</p>
        <router-link
            v-for="program in programs"
            :key="program.id"
            :to="'/org/' + $route.params.sub_level + '/' + $route.params.id + '/sneha-sparsham/' + program.id + '/intro'"
            class="d-block mb-2"
        >
            <button type="button" class="btn btn-outline-primary mal-text btn-lg col-12 text-start">
                {{ program.button_label || program.title }}
                <ion-icon name="chevron-forward-outline" class="float-end" style="font-size: 28px;"></ion-icon>
            </button>
        </router-link>
        <p v-if="programs.length === 0" class="text-center text-danger mal-text">പദ്ധതികൾ ലഭ്യമല്ല.</p>
    </div>
</template>

<script>
import UserService from "@/services/user.service";

export default {
    name: "SnehaSparsham",
    data() {
        return {
            loading: true,
            programs: [],
        };
    },
    mounted() {
        this.$root.updateParent("സ്നേഹ സ്പർശം");
        this.loadPrograms();
    },
    methods: {
        loadPrograms() {
            UserService.authPostRequest("get-sneha-sparsham-programs", {}).then((res) => {
                this.loading = false;
                if (res.data.status === "success") {
                    this.programs = res.data.data.programs || [];
                }
            }).catch(() => {
                this.loading = false;
            });
        },
    },
};
</script>
